var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { minWidthMedia } from "@irati/ui/src/global/media";
import { TROPHY_SIZE } from "../constants";
var TrophyContainer = styled("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  ", "\n"], ["\n  width: ", ";\n  ",
    "\n"])), function (_a) {
    var isTrophySelected = _a.isTrophySelected;
    return (isTrophySelected ? "100%" : TROPHY_SIZE + "px");
}, minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ",
    "\n  "])), function (_a) {
    var isTrophySelected = _a.isTrophySelected;
    return isTrophySelected && "\n      transition: width 0.5s ease;\n    ";
}));
export default TrophyContainer;
var templateObject_1, templateObject_2;
